import React, { useEffect, useMemo, useState } from 'react';
import Modal from '@Shared.Angular/flowingly.components/Modal/Modal';
import TagList from '@Shared.Angular/flowingly.components/TagList/TagList';
import ITagGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagGroupDetail';
import { Guid } from '@Shared.Angular/@types/guid';
import { getService } from '@Client/runner.hooks/useService';

export type Props = {
  stepName: string;
  stepTagIds: Guid[];
  onClose?: () => void;
};

const FlowStepTagsModal = ({ stepName, stepTagIds, onClose }: Props) => {
  const [tagGroups, setTagGroups] = useState<ITagGroupDetail[]>([]);
  const tagGroupApiService = getService('tagGroupApiService');

  const stepTagsSet = useMemo(() => new Set(stepTagIds), [stepTagIds]);

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    const tagGroups = await tagGroupApiService.getAllTagGroups();

    const filteredTagGroups = tagGroups
      .map((group) => ({
        ...group,
        tags: group.tags.filter((tag) => stepTagsSet.has(tag.id))
      }))
      .filter((group) => group.tags.length > 0);

    setTagGroups(filteredTagGroups);
  };

  const tagGroupsFormatted = (tagGroups: ITagGroupDetail[]) => {
    const result: Record<string, { tagNames: string[]; color: string }> = {};
    tagGroups.forEach((group) => {
      result[group.name] = {
        tagNames: group.tags.map((tag) => tag.name),
        color: group.color
      };
    });
    return result;
  };

  return (
    <Modal
      title={stepName}
      onClose={onClose}
      onCancelClick={onClose}
      hideActionButton={true}
      cancelButtonText={'Close'}
      size="lg"
    >
      <div className="flow-step-tag-container">
        <div className="flow-step-tag-step-name">Step Tags</div>
        <TagList tagsByGroupName={tagGroupsFormatted(tagGroups)} />
      </div>
    </Modal>
  );
};

export default FlowStepTagsModal;
